<template>
    <div class="index-wrap">
      <pull-refresh :refreshing="isRefreshing" :tipHeight ="'45px'" :on-refresh="onRefresh">
        <home-banner :bannerList="bannerList"></home-banner>
        <!--推荐内容-->
        <home-content :columnList="columList"></home-content>
      </pull-refresh>
      <!-- 引入公共footer -->
      <dg-footer  ></dg-footer>
    </div>
</template>
<script>
import DgFooter from '@/components/footer'
import HomeBanner from './components/banner'
import HomeContent from './components/content'
import pullRefresh from "@/components/pullRefresh.vue";
import api from '@/server'
export default {
  data () {
    return { // title标题 isShow(false)不显示返回键 (true)显示返回键
      title: '',
      isShow: true,
      searchStr: '',
      bannerList: [], // banner 数据
      columList: [], // 栏目数据
      isRefreshing: false
    }
  },
  components: {
    DgFooter,
    HomeBanner,
    HomeContent,
    pullRefresh
  },
  mounted() {

  },
  watch: {

  },
  methods: {
    // 首页搜索
    handlerStr (str) {
      this.searchStr = str;
    },
    // 请求首页banner数据
    bannerPoster () {
      api.bannerPoster().then(res => {
        if(res.code === 200 && res.data){
          res.data.forEach(item=> {
            item.active = false
          });
          this.bannerList = res.data;
          this.isRefreshing = false;
        }else{
          this.bannerList = []
        }
      }).catch(() => {})
    },
    // 请求栏目数据
    getColumnData () {
      api.getColumnData(this.params).then(res => {
        if(res.code === 200 && res.data){
          this.columList = res.data
        }else{
          this.columList = []
        }

      }).catch(() => {})
    },
    onRefresh() {
      this.isRefreshing = true;
      setTimeout(() => {
        this.bannerPoster(); // 首页banner数据
        this.getColumnData(); // 首页栏目数据
      }, 0)
    },
  },
  created () {
    this.bannerPoster(); // 首页banner数据
    this.getColumnData(); // 首页栏目数据
  },
}
</script>

<style lang="scss" scoped>
.index-wrap {
  width: 100%;
  height: auto;
}
</style>
